/**
 * useTranslation — convenience hook that surfaces just the t() function.
 *
 * Usage:
 *   const { t } = useTranslation()
 *   t('nav.dashboard')                           // → 'Dashboard'
 *   t('stream.viewers', { count: 150 })          // → '150 viewers'
 *   t('missing.key')                             // → 'missing.key' (fallback)
 */

import { useI18n } from './index'
import type { TranslationKey, TranslationParams, Locale } from './types'

export interface UseTranslationReturn {
  /** Translate a dot-notation key with optional interpolation params */
  t: (key: TranslationKey, params?: TranslationParams) => string
  /** Current locale code, e.g. 'en' */
  locale: Locale
  /** Switch locale */
  setLocale: (locale: Locale) => void
}

export function useTranslation(): UseTranslationReturn {
  const { t, locale, setLocale } = useI18n()
  return { t, locale, setLocale }
}
